// extracted by mini-css-extract-plugin
export default {"container":"legal_basis-module__container--1MUSY","legislation":"legal_basis-module__legislation--2YrWO"};